import React from "react";
import PropTypes from "prop-types";
import RelativeLink from "../common/RelativeLink";
import * as DomainConstants from "../../constants/DomainConstants";

const ValidationStatusList = ({ items, itemsFrontend, dossierType }) => {
    const route = {
        0: "aanvraag",
        1: "project",
        2: "minimaleeisen",
        3: "bovenlokaliteit",
        4: "beoordelingscriteriabovenlokaal",
        5: "beoordelingscriteriatopsport",
        6: "minimaleeisen",
        7: "bovenlokaliteit",
        17: "financieel"
    };

    function createUrl(tabnummer, dossierId, infrastructuurId) {
        let url = "/" + route[tabnummer] + "/" + dossierId;
        if (infrastructuurId) {
            url += ("/infrastructuur/" + infrastructuurId);
        }
        return url;
    }

    let ulStyle = {
        padding: '0 3.33333%',
        fontSize: '.875rem'
    };

    function compare(a, b) {
        if (a.tab < b.tab)
            return -1;
        if (a.tab > b.tab)
            return 1;
        return 0;
    }



    let sortedItems = [];
    Object.assign(sortedItems, items);
    sortedItems.sort(compare);

    itemsFrontend = itemsFrontend ? itemsFrontend : [];

    return (
        <ul style={ulStyle}>
            {sortedItems.map((item, i) => {
                let link = null;

                if (item.warnings > 0) {
                    let message = "";

                    if (item.opmerking) {
                        message = item.opmerking + " bij " + item.titel;
                    } else if (item.warnings == 1) {
                        message = item.warnings + " fout bij " + item.titel;
                    } else {
                        message = item.warnings + " fouten bij " + item.titel;
                    }

                    let url = createUrl(item.tab, item.master, item.infrastructuurId);
                    /*
                if(item.tab == 4 && (item.opmerking || item.warnings > 0)){
                    if(dossierType == DomainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_NIEUWBOUW || dossierType == DomainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE){
                        url = createUrl(5, item.master, item.infrastructuurId);
                    }
                }*/


                    link = (<li key={i}>
                        <RelativeLink key={i} to={url} className={"minimal"}>{message}</RelativeLink>
                        <br />
                    </li>);
                }
                return link;
            })}

            {itemsFrontend.map((item, i) => {
                return (
                    <li key={i}>
                        <RelativeLink key={"frontend_warning" + i} to={item.url} className={"minimal"}>{item.text}</RelativeLink>
                        <br />
                    </li>
                );
            })}
        </ul>
    );
};

ValidationStatusList.propTypes = {
    items: PropTypes.array,
    dossierType: PropTypes.number,
    itemsFrontend: PropTypes.array
};

export default ValidationStatusList;